import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { IssueType, IssueStatus } from '@/utils/type';
import IssueApi from '@/fetch/bussiness/issue';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useNavigate } from 'react-router-dom';
import CompleteIssueModal from '@/components/CompleteIssueModal';
import TransferIssueModal from '@/components/TransferIssueModal';
import OnHoldIssueModal from '@/components/OnHoldIssueModal';
import DiscardIssueModal from '@/components/DiscardIssueModal';
import { isEmpty } from 'lodash';
import { clstagStr, getClstag, showMsg } from '@/utils/util';
import { ListenModeClstag } from '@/utils/constant';
import ReminderModal from '@/components/ReminderModal';
import { useIsTakeOverBySelf } from '@/utils/hooks';

const RenderBottomBtn = ({
  issueInfo,
  isNotification,
  cockpitNumber,
  LC_BUTTON_R2,
}: {
  issueInfo: any;
  isNotification?: boolean;
  cockpitNumber: string;
  LC_BUTTON_R2?: boolean;
}) => {
  const navigator = useNavigate();
  const fetchApi = new IssueApi();
  const { login, issue, newCommon } = (window as any).store.getState();
  const isHasProcess = issue?.list?.filter(
    (val: any) => val.issueStatus === IssueStatus.PROCESS
  );
  const isTakeOverBySelf = useIsTakeOverBySelf();
  const [remindReportModal, setRemindReportModal] = useState(false);
  const [openCompleteIssueModal, setOpenCompleteIssueModal] = useState(false);
  const [openTransferIssueModal, setOpenTransferIssueModal] = useState(false);
  const [openOnHoldIssueModal, setOpenOnHoldIssueModal] = useState(false);
  const [holdIssueModalType, setHoldIssueModalType] = useState<
    'HOLD' | 'CANCEL_HOLD'
  >('HOLD');
  const [openDiscardIssueModal, setOpenDiscardIssueModal] = useState(false);

  /**
   * 接单
   */
  const handleAcceptIssue = async () => {
    const res = await fetchApi.acceptIssue({
      issueNumber: issueInfo?.issueNumber,
      cockpitNumber: cockpitNumber,
      acceptUsername: login?.userInfo?.userName,
    });
    if (res.code === HttpStatusCode.Success) {
      fetchApi.cancelNewIssue([issueInfo?.issueNumber], cockpitNumber);
      if (issueInfo?.issueType === IssueType.OPS) {
        if (isTakeOverBySelf) {
          message.error('您已在接管车辆中，请先退出接管');
          return;
        }
        navigator(`/app/singleview?vehicleName=${issueInfo?.vehicleName}`);
      }
    }
  };

  /**
   * 查看工单
   */
  const handleCheckIssue = () => {
    fetchApi.cancelNewIssue([issueInfo?.issueNumber], cockpitNumber);
    if (issueInfo?.issueType === IssueType.OPS) {
      if (isTakeOverBySelf) {
        message.error('您已在接管车辆中，请先退出接管');
        return;
      }
      navigator(`/app/singleview?vehicleName=${issueInfo?.vehicleName}`);
    }
  };
  /**
   * 挂单
   */
  const handleHoldIssue = async () => {
    setHoldIssueModalType('HOLD');
    setOpenOnHoldIssueModal(true);
  };
  /**
   * 取消挂单
   */
  const handelCancelHoldIssue = async () => {
    setHoldIssueModalType('CANCEL_HOLD');
    setOpenOnHoldIssueModal(true);
  };
  /**
   * 点击抛单按钮
   */
  const handleDiscardIssue = () => {
    setOpenDiscardIssueModal(true);
  };

  /**
   * 点击转单按钮
   */
  const handleTransferIssue = async () => {
    setOpenTransferIssueModal(true);
  };

  /**
   * 点击结单按钮
   */
  const handleCompleteIssue = () => {
    getCurrentIssueEventInfo();
  };
  const getCurrentIssueEventInfo = async () => {
    try {
      const res = await fetchApi.getIssueEvent({
        issueNumber: issueInfo?.issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        if (res.data.accidentProcessed) {
          setOpenCompleteIssueModal(true);
        } else {
          setOpenCompleteIssueModal(false);
          setRemindReportModal(true);
        }
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  const renderBtns = () => {
    if (issueInfo.emergencyIssue) {
      return (
        <Button type="primary" onClick={handleAcceptIssue}>
          受理（将挂起正处理的工单）
        </Button>
      );
    }
    if (issueInfo.issueStatus === IssueStatus.PROCESS && isNotification) {
      return (
        <Button
          onClick={handleCheckIssue}
          clstag={clstagStr(ListenModeClstag.Notification_GoSingle)}
        >
          查看详情
        </Button>
      );
    }
    const btnMap: any = {
      'PROCESS+OPS': (
        <>
          <Button
            onClick={handleHoldIssue}
            clstag={clstagStr(ListenModeClstag.Card_OnHold)}
          >
            挂单
          </Button>
          <Button
            onClick={handleDiscardIssue}
            clstag={clstagStr(ListenModeClstag.Card_Discard)}
          >
            抛单
          </Button>
          <Button
            onClick={handleTransferIssue}
            clstag={clstagStr(ListenModeClstag.Card_Transfer)}
          >
            转单
          </Button>
          <Button
            type="primary"
            onClick={handleCompleteIssue}
            clstag={clstagStr(ListenModeClstag.Card_Complete)}
          >
            结单
          </Button>
        </>
      ),
      'PROCESS+PROBLEM_REPORT': (
        <>
          <Button
            onClick={handleHoldIssue}
            clstag={clstagStr(ListenModeClstag.Card_OnHold)}
          >
            挂单
          </Button>
          <Button
            type="primary"
            onClick={handleCompleteIssue}
            clstag={clstagStr(ListenModeClstag.Card_Complete)}
          >
            结单
          </Button>
        </>
      ),
      'ON_HOLD+PROBLEM_REPORT': (
        <Button type="primary" onClick={handelCancelHoldIssue}>
          {!isEmpty(isHasProcess)
            ? '取消挂单（将挂起正处理的工单）'
            : '取消挂单'}
        </Button>
      ),
      'ON_HOLD+OPS': (
        <>
          <Button
            onClick={handleDiscardIssue}
            clstag={clstagStr(ListenModeClstag.Card_Discard)}
          >
            抛单
          </Button>
          <Button
            onClick={handleTransferIssue}
            clstag={clstagStr(ListenModeClstag.Card_Transfer)}
          >
            转单
          </Button>
          <Button type="primary" onClick={handelCancelHoldIssue}>
            {!isEmpty(isHasProcess)
              ? '取消挂单（将挂起正处理的工单）'
              : '取消挂单'}
          </Button>
        </>
      ),
    };
    return btnMap[`${issueInfo?.issueStatus}+${issueInfo?.issueType}`];
  };

  return (
    <>
      {renderBtns()}

      <CompleteIssueModal
        open={openCompleteIssueModal}
        setOpen={setOpenCompleteIssueModal}
        issueNumber={issueInfo?.issueNumber}
        issueStatus={issueInfo?.issueStatus}
        vehicleName={issueInfo?.vehicleName}
        LC_BUTTON_R2={LC_BUTTON_R2}
      />

      <TransferIssueModal
        open={openTransferIssueModal}
        setOpen={setOpenTransferIssueModal}
        vehicleName={issueInfo.vehicleName}
        type="TRANSFER"
      />

      {openOnHoldIssueModal && (
        <OnHoldIssueModal
          open={openOnHoldIssueModal}
          setOpen={setOpenOnHoldIssueModal}
          vehicleName={issueInfo?.vehicleName}
          issueNumber={issueInfo?.issueNumber}
          showOnHold={issueInfo?.issueStatus === IssueStatus.PROCESS}
          showCancelOnHold={issueInfo?.issueStatus === IssueStatus.ON_HOLD}
        />
      )}
      <DiscardIssueModal
        open={openDiscardIssueModal}
        setOpen={setOpenDiscardIssueModal}
        vehicleName={issueInfo?.vehicleName}
        issueNumber={issueInfo?.issueNumber}
        issueStatus={issueInfo?.issueStatus}
      />
      <ReminderModal
        vehicleName={issueInfo?.vehicleName}
        remindReportModal={remindReportModal}
        setRemindReportModal={setRemindReportModal}
      />
    </>
  );
};

export default React.memo(RenderBottomBtn);
